import { render, staticRenderFns } from "./PaymentHistoryChart.vue?vue&type=template&id=54e3f36b&scoped=true"
import script from "./PaymentHistoryChart.vue?vue&type=script&lang=js"
export * from "./PaymentHistoryChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54e3f36b",
  null
  
)

export default component.exports